export default "__VITE_ASSET__DdaVFfX7__"